export default "__VITE_ASSET__JsbHatuj__"